import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated } from './auth-store';

/** Redirects unauthenticated users to /login, preserving the intended destination. */
export function AuthGuard({ children }: { children: ReactNode }) {
	const isAuthenticated = useIsAuthenticated();
	const location = useLocation();

	if (!isAuthenticated) {
		return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
	}
	return <>{children}</>;
}
